/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacy_Accept_BeforeInputs */

const es_footer_privacy_accept_before = /** @type {(inputs: Footer_Privacy_Accept_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acepto la `)
};

const gl_footer_privacy_accept_before = /** @type {(inputs: Footer_Privacy_Accept_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acepto a `)
};

const en_footer_privacy_accept_before = /** @type {(inputs: Footer_Privacy_Accept_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I accept the `)
};

/**
* | output |
* | --- |
* | "I accept the" |
*
* @param {Footer_Privacy_Accept_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_privacy_accept_before = /** @type {((inputs?: Footer_Privacy_Accept_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacy_Accept_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_privacy_accept_before(inputs)
	if (locale === "en") return en_footer_privacy_accept_before(inputs)
	return es_footer_privacy_accept_before(inputs)
});